export function useDesign(scope: string) {
  return {
    prefixCls: `tp-${scope}`,
    prefixVar: 'tp',
  }
}
